// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// import touch from 'vue-directive-touch'
import { List, Toast, Dialog, Empty } from 'vant'
import App from './App'
import router from './router'
import store from './store'
import VueLazyload from 'vue-lazyload'
import * as filters from './filters'
import { getImg, ImgHost } from './services/urlService'
import kkUtil from './assets/js/kk-util'
import Axios from 'axios'
import CryptoJS from "crypto-js";

Toast.setDefaultOptions('loading', { duration: 1000 * 1000 })
Vue.config.productionTip = false
// Vue.use(touch)

let jsKey = CryptoJS.enc.Utf8.parse('ZVqAI6jw54IkfLZH');
Vue.use(VueLazyload, {
  adapter: {
    loaded (listener, Init) {
      let jsUrl = getImg(kkUtil.getJsPath(listener.el.getAttribute('imgpath')))
      Axios.create({
        headers: {
          'Content-Type': 'text/plain'
        },
      }).get(jsUrl).then(res => {
        if (res.status === 200) {
          listener.el.src = 'data:image/png;base64,' + kkUtil.aesDecrypt(res.data + '', jsKey)
        } else if (res.status === 204) {
          listener.el.src = require('./assets/img/icon-e.png')
        }
      })
    }
  }
})

Vue.use(Toast)
Vue.use(Dialog)
Vue.component(List.name, List)
Vue.component(Empty.name, Empty)
// FastClick.attach(document.body)
Object.keys(filters).forEach(k => Vue.filter(k, filters[k]))
/* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   router,
//   store,
//   components: { App },
//   template: '<App/>'
// })
try {
  store.dispatch('fetchCommonInfo')
  store.dispatch('fetchBookSearch')
} catch (error) {
  console.error(error)
}

const mixin = {
  methods: {
    getCoverUrl (url) {
      if (url) {
        return `${ImgHost}${url}`
      }
      return ''
    }
  }
}
Vue.mixin(mixin)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
